export default "__VITE_ASSET__D7C95RYd__"